"use client";

import { useState } from "react";
import { useRouter } from "next/navigation";

const PJK = "'Plus Jakarta Sans', var(--font-plus-jakarta), sans-serif";
const URB = "var(--font-urbanist), sans-serif";

interface RatingModalProps {
  onSubmit?: (rating: number, feedback: string) => void;
  onSkip?: () => void;
  onClose?: () => void;
}

export default function RatingModal({ onSubmit, onSkip, onClose }: RatingModalProps = {}) {
  const router = useRouter();
  const [rating, setRating] = useState(4);
  const [hoverRating, setHoverRating] = useState(0);
  const [feedback, setFeedback] = useState("");
  const [bounceKey, setBounceKey] = useState<number | null>(null);

  const handleSubmit = () => {
    if (onSubmit) onSubmit(rating, feedback);
    else router.push("/app");
  };
  const handleSkip = () => {
    if (onSkip) onSkip();
    else router.push("/app");
  };

  const handleStarClick = (n: number) => {
    setRating(n);
    setBounceKey(n);
    setTimeout(() => setBounceKey(null), 200);
  };

  const displayRating = hoverRating || rating;

  return (
    <div
      className="app-anim-scale-in desktop-glass-rating-modal"
      style={{
        width: 440,
        maxWidth: 440,
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        background: "rgba(242,240,237,0.04)",
        border: "1px solid rgba(75,68,85,0.2)",
        borderRadius: 16,
        padding: 25,
        display: "flex",
        flexDirection: "column",
        gap: 24,
        alignItems: "flex-start",
        position: "relative",
        boxShadow: "0px 25px 50px -12px rgba(0,0,0,0.25)",
      }}
    >
      {/* Heading */}
      <div style={{ width: "100%", display: "flex", flexDirection: "column", alignItems: "center" }}>
        <h2
          style={{
            fontFamily: PJK,
            fontWeight: 700,
            fontSize: 24,
            lineHeight: "32px",
            color: "#F2F0ED",
            margin: 0,
            textAlign: "center",
          }}
        >
          How was the result?
        </h2>
      </div>

      {/* Star Rating */}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "flex-start",
          justifyContent: "center",
          gap: 12,
          paddingBottom: 8,
        }}
      >
        {[1, 2, 3, 4, 5].map((n) => (
          <button
            key={n}
            onClick={() => handleStarClick(n)}
            onMouseEnter={() => setHoverRating(n)}
            onMouseLeave={() => setHoverRating(0)}
            aria-label={`${n} star${n === 1 ? "" : "s"}`}
            className="app-star-btn"
            style={{
              width: 36,
              height: 36,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "transparent",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
          >
            <img
              src={
                n <= displayRating
                  ? "/app-icons/star-large.svg"
                  : "/app-icons/star-large-outline.svg"
              }
              alt=""
              className={bounceKey === n ? "app-anim-star-bounce" : undefined}
              style={{ width: 25.263, height: 24 }}
            />
          </button>
        ))}
      </div>

      {/* Feedback Textarea */}
      <textarea
        value={feedback}
        onChange={(e) => setFeedback(e.target.value)}
        placeholder="Share your experience... (optional)"
        className="app-rating-textarea"
        style={{
          width: "100%",
          height: 100,
          background: "#2C2B2B",
          border: "1px solid #353535",
          borderRadius: 12,
          paddingLeft: 17,
          paddingRight: 17,
          paddingTop: 13,
          paddingBottom: 33,
          fontFamily: PJK,
          fontWeight: 400,
          fontSize: 14,
          lineHeight: "20px",
          color: "#F2F0ED",
          resize: "none",
          outline: "none",
          boxSizing: "border-box",
        }}
      />

      {/* Actions */}
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 16,
          alignItems: "center",
        }}
      >
        <button
          onClick={handleSubmit}
          className="app-btn-primary"
          style={{
            background: "#8635F6",
            borderRadius: 9999,
            width: "100%",
            padding: "16px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            border: "none",
            cursor: "pointer",
          }}
        >
          <span
            style={{
              fontFamily: URB,
              fontWeight: 700,
              fontSize: 16,
              lineHeight: "24px",
              color: "#F2F0ED",
              textAlign: "center",
            }}
          >
            Submit
          </span>
        </button>

        <button
          onClick={handleSkip}
          className="app-text-link"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            color: "#D5BAFF",
          }}
        >
          <span
            style={{
              fontFamily: PJK,
              fontWeight: 600,
              fontSize: 14,
              lineHeight: "21px",
              color: "inherit",
              textAlign: "center",
            }}
          >
            Skip
          </span>
        </button>
      </div>
    </div>
  );
}
